import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/movies/browse/$type/$filter')({})
